import { render } from "./App.vue?vue&type=template&id=5bdc0a80"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=5bdc0a80&lang=css"

import exportComponent from "C:\\Users\\Korbin\\Documents\\Vue\\vuetutorial\\reaction-timer\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__